// One platypus sticker image; hides itself when it cannot be loaded (offline, not cached yet).
import { useState } from 'react';
import { stickerUrl } from '../lib/stickers';

interface Props {
  id: string;
  size: number;
  className?: string;
}

export function Sticker({ id, size, className }: Props) {
  const [failed, setFailed] = useState<string | null>(null);
  if (failed === id) return null;
  return (
    <img
      src={stickerUrl(id)}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      decoding="async"
      draggable={false}
      className={`sticker${className ? ` ${className}` : ''}`}
      onError={() => setFailed(id)}
    />
  );
}
